import { pushEcommerceEvent } from '@app/infrastructure/gtm/pushEcommerceEvent';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { EcommerceItem } from '@app/domain/model/gtm/EcommerceItem';
import { GtmItemCategory } from '@app/domain/model/gtm/GtmItemCategory';
import { PersonalInsuranceRiskPackage } from '@app/domain/model/eshop/personal-accidents/PersonalInsuranceRiskPackage';

export function trackAddToCart(selectedRisk?: Nullable<PersonalInsuranceRiskPackage>): void {
    if (!selectedRisk) {
        return;
    }

    const price = selectedRisk.premiumAfterDiscount ?? selectedRisk.premium ?? 0;

    if (price === 0) {
        return;
    }

    const items: EcommerceItem[] = [
        {
            item_name: selectedRisk.name,
            item_id: selectedRisk.code,
            price,
            item_category: GtmItemCategory.PersonalAccidentsInsurance,
            quantity: 1,
        },
    ];

    pushEcommerceEvent(GtmEventName.AddToCart, {
        currency: 'EUR',
        value: price,
        items,
    });
}
